import React from 'react';

/**
 * Email icon for email management navigation
 * Represents emails, communications, messaging, and correspondence
 */
const EmailIcon: React.FC = () => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24"
    strokeWidth={1.5} 
    stroke="currentColor" 
    className="w-5 h-5"
    aria-hidden="true"
  >
    <path 
      strokeLinecap="round" 
      strokeLinejoin="round"
      d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.32 0L8.32 8.909a2.25 2.25 0 01-1.07-1.916V6.75" 
    />
  </svg>
);

export default EmailIcon;
